<template>
  <div>
    <modal id="add-tag">
      <h5 slot="header">
        <strong>Unesite novi tag</strong>
      </h5>
      <div slot="body">
        <div class="row">
          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Tag
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Tag"
                v-model="tagName"
              />
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.stop.prevent="saveTag()"
            >
              {{ translations.save }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.cancel }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal id="add-brand">
      <h5 slot="header">
        <strong>Unesite novi brend</strong>
      </h5>
      <div slot="body">
        <div class="row">
          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Naziv
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Brend"
                v-model="brand.title"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
              >Opis</label
            >
            <div class="col-lg-7 col-xl-6">
              <textarea
                type="text"
                class="form-control form-control-modern"
                placeholder="Opis"
                v-model="brand.description"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
              >Slika</label
            >
            <div class="col-lg-7 col-xl-6">
              <input
                type="file"
                class="form-control form-control-modern"
                ref="brandImage"
                accept="image/*"
              />

              <span class="form-text">
                Učitajte sliku rezolucije 200px x 60px
              </span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.stop.prevent="saveBrand()"
            >
              {{ translations.save }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.cancel }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- start: page -->
    <form
      @submit.prevent="submitForm"
      class="ecommerce-form action-buttons-fixed"
      novalidate
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.articleDetails }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.articleDetailsInfo }}
                  </p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <!-- <div
                    class="form-group row align-items-center pb-3"
                    :class="{ 'has-danger': $v.article.companyId.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.company }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div :class="{ has__error: $v.article.companyId.$anyError }">
                        <treeselect
                          v-model="article.companyId"
                          :multiple="false"
                          :options="companies"
                          :show-count="true"
                          placeholder="Izaberite kompaniju"
                        />
                      </div>
                      <form-error
                        :model="$v.article.companyId"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.company"
                      />
                    </div>
                  </div> -->

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.article.code.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >{{ translations.forms.labels.code }}</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.code"
                        v-model="article.code"
                        @input="checkIfArticleCodeExists"
                      />

                      <form-error
                        :model="$v.article.code"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.code"
                      />
                      <label
                        v-if="articleCodeExists"
                        class="article-code-error"
                        >{{
                          translations.forms.labels.articleCodeExists
                        }}</label
                      >
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.article.title.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.title }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="article.title"
                      />

                      <form-error
                        :model="$v.article.title"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.title"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Status artikla
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="article.articleState"
                        :options="articleStates"
                        placeholder="Izaberite status artikla"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.isVisibleOnWeb }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="article.isVisibleOnWeb"
                          id="visible-on-web"
                        />
                        <label for="visible-on-web"></label>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{ 'has-danger': $v.article.categoryIds.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.category }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div
                        :class="{
                          has__error: $v.article.categoryIds.$anyError,
                        }"
                      >
                        <treeselect
                          v-model="article.categoryIds"
                          :multiple="true"
                          :options="categoriesTreeView"
                          :show-count="true"
                          placeholder="Izaberite kategoriju"
                          v-if="categoriesTreeView"
                        />
                      </div>

                      <form-error
                        :model="$v.article.categoryIds"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.category"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.brand }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="article.brandId"
                      >
                        <option :value="null">Izaberite brend</option>
                        <option
                          :value="brand.id"
                          :key="brand.id"
                          v-for="brand in brands"
                        >
                          {{ brand.title }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-1 col-xl-1">
                      <button
                        class="btn btn-primary btn-md font-weight-semibold py-2 px-4"
                        type="button"
                        @click="addBrand()"
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.interestsArea }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="article.interestsAreasIds"
                        :multiple="true"
                        :options="areas"
                        placeholder="Izaberite djelatnost"
                        no-options-text="Nema unesenih djelatnosti."
                        @select="handleChangeAreas"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.catalogNumber }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.catalogNumber"
                        v-model="article.catalogNumber"
                      />

                      <!-- <form-error :model="$v.article.catalogNumber" :dirty="$v.$dirty" label="Kataloški broj" /> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end pt-2 mt-1 mb-0"
                    >
                      {{ translations.forms.labels.shortDescription }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <editor
                        name="html-editor"
                        :init="{
                          ...appSettings.tinyMceConfig
                        }"
                        v-model="article.shortDescription"
                        id="short-description"
                      ></editor>

                      <!-- <form-error :model="$v.article.shortDescription" :dirty="$v.$dirty" label="Kratak opis" /> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end pt-2 mt-1 mb-0"
                    >
                      {{ translations.forms.labels.description }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <editor
                        name="html-editor"
                        :init="{
                          ...appSettings.tinyMceConfig,
                        }"
                        v-model="article.description"
                        id="description"
                      ></editor>

                      <div class="form-text">
                        Molimo koristite slike ne veće rezolucije od 600px x
                        600px
                      </div>

                      <!-- <form-error :model="$v.article.description" :dirty="$v.$dirty" label="Opis" /> -->
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3 d-none"
                    :class="{ 'has-danger': $v.article.nc.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.nc }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.nc"
                        v-model.number="article.nc"
                      />

                      <form-error
                        :model="$v.article.nc"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.nc"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Stanje skladišta
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Stanje skladišta"
                        :value="article.stockAmount"
                        readonly
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.article.mpc.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.mpc }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.mpc"
                        v-model.number="article.mpc"
                        @input="handleMpcChange"
                      />

                      <form-error
                        :model="$v.article.mpc"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.mpc"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.taxGroup }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="article.taxId"
                      >
                        <option :value="null">Izaberite poreznu grupu</option>
                        <option
                          :value="tax.id"
                          :key="tax.id"
                          v-for="tax in taxes"
                        >
                          {{ tax.description }}
                        </option>
                      </select>

                      <!-- <form-error :model="$v.article.taxId" :dirty="$v.$dirty" label="Porezna grupa" /> -->
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.article.vpc.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.vpc }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.vpc"
                        v-model.number="article.vpc"
                        @input="handleVpcChange"
                      />

                      <form-error
                        :model="$v.article.vpc"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.vpc"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.unitOfMeasure }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="article.unitOfMeasureId"
                      >
                        <option :value="null">Izaberi jedinicu mjere</option>
                        <option
                          :value="unit.id"
                          :key="unit.id"
                          v-for="unit in measurementUnits"
                        >
                          {{ unit.description }}
                        </option>
                      </select>

                      <!-- <form-error :model="$v.article.unitOfMeasureId" :dirty="$v.$dirty" label="Jedinica mjere" /> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.nettoWeight }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.nettoWeight"
                        v-model="article.nettoWeight"
                      />

                      <!-- <form-error :model="$v.article.nettoWeight" :dirty="$v.$dirty" label="Netto težina" /> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.bruttoWeight }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.bruttoWeight"
                        v-model="article.bruttoWeight"
                      />

                      <!-- <form-error :model="$v.article.bruttoWeight" :dirty="$v.$dirty" label="Netto težina" /> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Omjer narudžbe
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Omjer narudžbe"
                        @change="handleOrderQuantityRatio"
                        v-model.number="article.orderQuantityRatio"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger': $v.article.minOrderQuantity.$anyError,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Minimalna količina za narudžbu
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        @change="handleMinOrderQuantity"
                        placeholder="Minimalna količina za narudžbu"
                        v-model.number="article.minOrderQuantity"
                      />

                      <form-error
                        :model="$v.article.minOrderQuantity"
                        :dirty="$v.$dirty"
                        label="Minimalna količina za narudžbu"
                      />
                      <!-- <div class="form-text">
                        Ukoliko mijenjate polje "Omjer narudžbe" potrebno je
                        promjeniti i ovo polje na istu vrijednost
                      </div> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Maksimalna količina za narudžbu
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Maksimalna količina za narudžbu"
                        v-model.number="article.maxOrderQuantity"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Dužina
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Dužina"
                        v-model.number="article.length"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Širina
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Širina"
                        v-model.number="article.width"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Visina
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Visina"
                        v-model.number="article.height"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.article.videoUrl.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.videoUrl }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.videoUrl"
                        v-model="article.videoUrl"
                      />

                      <form-error
                        :model="$v.article.videoUrl"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.videoUrl"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.articleType }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="article.attributeArticleType"
                        :options="attributeArticleTypes"
                        :clearable="false"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.tag }}
                    </label>
                    <div class="col-lg-6 col-xl-6">
                      <treeselect
                        v-model="article.tagsIds"
                        :multiple="true"
                        :options="tags"
                        placeholder="Tagovi"
                      />
                    </div>
                    <div class="col-lg-1 col-xl-1">
                      <button
                        class="btn btn-primary btn-md font-weight-semibold py-2 px-4"
                        type="button"
                        @click="addTag()"
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Broj dana nakon kojih je artikal dostupan
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Broj dana nakon kojih je artikal dostupan"
                        v-model="article.articleAvailableInDays"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.markArticleAsNew }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="article.isNewArticle"
                          id="mark-as-new"
                          @change="handeIsNewArticleChange(article)"
                        />
                        <label for="mark-as-new"></label>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="article.isNewArticle"
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Početak</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <datepicker
                        placeholder="Početak"
                        v-model="article.isNewArticleFromDate"
                        input-class="form-control form-control-modern bg-body"
                        :monday-first="true"
                        :full-month-name="true"
                        :language="bs"
                        :format="customFormatter"
                        :disabled-dates="disabledDates"
                      ></datepicker>
                    </div>
                  </div>

                  <div
                    v-if="article.isNewArticle"
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Kraj
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <datepicker
                        placeholder="Kraj"
                        v-model="article.isNewArticleToDate"
                        input-class="form-control form-control-modern bg-body"
                        :monday-first="true"
                        :full-month-name="true"
                        :language="bs"
                        :format="customFormatter"
                        :disabled-dates="disabledDates"
                      ></datepicker>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Omogući prezentaciju artikla
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="article.presentationAvailable"
                          id="presentation-available"
                        />
                        <label for="presentation-available"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Onemogući prodaju B2B
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="article.disableSelling"
                          id="disable-selling"
                        />
                        <label for="disable-selling"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Onemogući prodaju B2C
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="article.disableSellingB2C"
                          id="disable-selling"
                        />
                        <label for="disable-selling"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Dozvoli recenzije
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="article.reviewAllowed"
                          id="review-allowed"
                        />
                        <label for="review-allowed"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      B2C Proizvod
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="article.b2CProduct"
                          id="b2c-product"
                        />
                        <label for="b2c-product"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      B2B Proizvod
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="article.b2BProduct"
                          id="b2b-product"
                        />
                        <label for="b2b-product"></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-detail"></i>
                  <h2 class="card-big-info-title">Tabovi</h2>
                  <p class="card-big-info-desc">Dodajte zeljene tabove</p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center">
                    <div class="col">
                      <div class="form-group row align-items-center pb-3">
                        <div class="col-4">
                          <select
                            class="form-control form-control-modern"
                            v-model="tabId"
                          >
                            <option :value="null">Izaberite tab</option>
                            <option
                              :value="tab.id"
                              :key="tab.id"
                              v-for="tab in tabs"
                            >
                              {{ tab.title }}
                            </option>
                          </select>
                        </div>
                        <div class="col-1">
                          <button
                            class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4"
                            type="button"
                            @click="addTab()"
                          >
                            +
                          </button>
                        </div>
                      </div>

                      <div
                        class="tabs"
                        v-if="
                          article && article.tabs && article.tabs.length > 0
                        "
                      >
                        <ul class="nav nav-tabs">
                          <li
                            class="nav-item"
                            v-for="(tab, index) in article.tabs"
                            :key="tab.tabId"
                          >
                            <a
                              class="nav-link"
                              :class="{
                                active: article.tabs.length === index + 1,
                              }"
                              :data-bs-target="`#tab${tab.tabId}`"
                              :href="`#tab${tab.tabId}`"
                              data-bs-toggle="tab"
                            >
                              {{ tab.tabTitle }}
                            </a>
                            <span
                              class="remove-tab"
                              @click.prevent.stop="removeTab(index)"
                              ><i class="bx bx-x"></i
                            ></span>
                          </li>
                        </ul>
                        <div class="tab-content">
                          <div
                            :id="`tab${tab.tabId}`"
                            class="tab-pane"
                            :class="{
                              active: article.tabs.length === index + 1,
                            }"
                            v-for="(tab, index) in article.tabs"
                            :key="tab.tabId"
                          >
                            {{ tab.description }}
                            <editor
                              name="html-editor"
                              :init="{
                                ...appSettings.tinyMceConfig,
                              }"
                              v-model="tab.content"
                              :id="`editor-${tab.tabId}`"
                            >
                            </editor>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="tabs-modern row" style="min-height: 490px">
                <div class="col-lg-2-5 col-xl-1-5">
                  <div
                    class="nav flex-column tabs"
                    id="tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <a
                      class="nav-link active"
                      id="attributes-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#attributes"
                      role="tab"
                      aria-controls="attributes"
                      >Atributi</a
                    >
                    <a
                      class="nav-link"
                      id="variation-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#advanced"
                      role="tab"
                      aria-controls="advanced"
                      >Varijacije</a
                    >
                  </div>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="tab-content" id="tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="attributes"
                      role="tabpanel"
                      aria-labelledby="attributes-tab"
                    >
                      <div class="form-group row">
                        <div class="col">
                          <div class="form-group row pb-3">
                            <div class="form-group row align-items-center pb-3">
                              <div class="col-4">
                                <select
                                  class="form-control form-control-modern"
                                  v-model="attributeId"
                                >
                                  <option :value="null">
                                    Izaberite atribut
                                  </option>
                                  <option
                                    :value="item.id"
                                    :key="item.id"
                                    v-for="item in allAttributes"
                                  >
                                    {{ item.title }}
                                  </option>
                                </select>
                              </div>
                              <div class="col-1">
                                <button
                                  class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4"
                                  type="button"
                                  @click="addAttribute()"
                                >
                                  +
                                </button>
                              </div>
                            </div>

                            <div
                              v-if="
                                article &&
                                article.articleAttributes &&
                                article.articleAttributes.length > 0
                              "
                              class="mt-5"
                            >
                              <div
                                class="form-group row pb-3"
                                v-for="(
                                  item, index
                                ) in article.articleAttributes"
                                :key="item.id"
                              >
                                <div class="col-xl-3">
                                  <label
                                    v-if="
                                      attributesObj &&
                                      attributesObj[item.attributeId]
                                    "
                                  >
                                    {{ attributesObj[item.attributeId].title }}
                                  </label>
                                </div>
                                <div class="col-xl-9">
                                  <div
                                    data-bs-toggle="modal"
                                    data-bs-target="#delete-attribute-modal"
                                    @click="selectLinkedAttribute(index)"
                                    class="ecommerce-attribute-remove text-color-danger float-end"
                                  >
                                    Ukloni
                                  </div>

                                  <label class="control-label"
                                    >Vrijednost(i)</label
                                  >

                                  <treeselect
                                    v-if="
                                      attributesObj &&
                                      attributesObj[item.attributeId]
                                    "
                                    :instance-id="item.attributeId"
                                    v-model="item.attributeValues"
                                    :multiple="true"
                                    :options="
                                      attributesObj[item.attributeId]
                                        .attributeProperties
                                    "
                                    @deselect="onAttributeChange"
                                  >
                                    <label
                                      slot="option-label"
                                      slot-scope="{ node, labelClassName }"
                                      :class="labelClassName"
                                    >
                                      <div
                                        v-if="
                                          attributesObj[item.attributeId]
                                            .attributeStyle !== 1
                                        "
                                      >
                                        {{ node.label }}
                                      </div>
                                      <div v-else>
                                        <div
                                          :style="{
                                            height: '20px',
                                            width: '20px',
                                            background: node.label,
                                          }"
                                        ></div>
                                      </div>
                                    </label>

                                    <div
                                      :style="{
                                        background: node.label,
                                      }"
                                      slot="value-label"
                                      slot-scope="{ node }"
                                    >
                                      <div
                                        v-if="
                                          attributesObj[item.attributeId]
                                            .attributeStyle === 1
                                        "
                                        :style="{
                                          backgroundColor: node.label,
                                          width: '20px',
                                          height: '20px',
                                          overflow: 'hidden',
                                        }"
                                      ></div>
                                      <div v-else>{{ node.label }}</div>
                                    </div>
                                  </treeselect>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="tab-pane fade" id="advanced" role="tabpanel">
                      <div class="form-group row pb-3">
                        <div class="row mt-1">
                          <div class="form-group row align-items-center mb-3">
                            <div
                              class="col col-4"
                              v-for="item in variationAttributes"
                              :key="item.id"
                            >
                              <label class="label">{{ item.label }}</label>

                              <treeselect
                                v-model="item.model"
                                :multiple="false"
                                :options="item.values"
                              >
                                <label
                                  slot="option-label"
                                  slot-scope="{ node, labelClassName }"
                                  :class="labelClassName"
                                >
                                  <div
                                    v-if="
                                      variationAttributesObj[item.id]
                                        .attributeStyle !== 1
                                    "
                                  >
                                    {{ node.label }}
                                  </div>
                                  <div v-else>
                                    <div
                                      :style="{
                                        height: '20px',
                                        width: '20px',
                                        background: node.label,
                                      }"
                                    ></div>
                                  </div>
                                </label>

                                <div
                                  slot="value-label"
                                  slot-scope="{ node }"
                                  :style="{
                                    width: '100%',
                                    height: '100%',
                                    padding:
                                      variationAttributesObj[item.id]
                                        .attributeStyle === 1
                                        ? '0.5rem 0'
                                        : 0,
                                  }"
                                >
                                  <div
                                    v-if="
                                      variationAttributesObj[item.id]
                                        .attributeStyle === 1
                                    "
                                    :style="{
                                      backgroundColor: node.label,
                                      width: '100%',
                                      height: '100%',
                                      overflow: 'hidden',
                                      border: '1px solid #ccc',
                                    }"
                                  ></div>
                                  <div v-else>{{ node.label }}</div>
                                </div>
                              </treeselect>
                            </div>
                          </div>
                          <div class="col-md-auto">
                            <button
                              class="btn btn-primary btn-px-3 py-3 font-weight-semibold"
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#add-variation-modal"
                              @click="selectVariation()"
                            >
                              Dodaj varijaciju
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        class="table-responsive"
                        v-if="variations.length > 0"
                      >
                        <table
                          class="table table-hover table-bordered table-variations"
                          style="min-width: 550px"
                        >
                          <thead>
                            <tr role="row">
                              <th>SKU</th>
                              <th>Atributi</th>
                              <th>Cijena</th>
                              <th>Cijena na popustu</th>
                              <th>Opis</th>
                              <th>Količina na zalihi</th>
                              <th>Dimenzije (DxŠxV)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, index) in variations"
                              :key="item.id"
                              :class="{
                                odd: index % 2 === 0,
                                even: index % 2 !== 0,
                              }"
                              data-bs-toggle="modal"
                              data-bs-target="#update-variation-modal"
                              @click="selectVariation(item)"
                            >
                              <td>
                                {{ item.code }}
                              </td>

                              <td>
                                <div
                                  v-if="Object.keys(attributesObj).length > 0"
                                >
                                  <div
                                    v-for="attribute in item.variationCombinations"
                                    :key="attribute.attributeId"
                                  >
                                    {{
                                      attributesObj[attribute.attributeId]
                                        .title
                                    }}:
                                    {{
                                      attributesObj[
                                        attribute.attributeId
                                      ].attributeProperties.find(
                                        (i) =>
                                          attribute.attributeValueId === i.id
                                      ).label
                                    }}
                                  </div>
                                </div>
                              </td>

                              <td>
                                {{ item.mpc }}
                              </td>

                              <td>
                                {{ item.salePrice }}
                              </td>

                              <td class="text-hidden" :title="item.description">
                                {{ item.description || 'N/A' }}
                              </td>

                              <td>
                                {{ item.stockAmount }}
                              </td>

                              <td>
                                {{ item.length }} x {{ item.width }} x
                                {{ item.height }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-detail"></i>
                  <h2 class="card-big-info-title">Povezani artikli</h2>
                  <p class="card-big-info-desc">Dodajte željene artikle</p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center">
                    <div class="col">
                      <div class="form-group row pb-3">
                        <label
                          class="
                            col-lg-5 col-xl-3
                            control-label
                            text-lg-end
                            mb-0
                            mt-2
                          "
                          >Pretraga artikala</label
                        >
                        <div class="col-lg-7 col-xl-6 position-relative">
                          <input
                            type="text"
                            class="search-term form-control"
                            placeholder="Pretraga"
                            v-model="searchField"
                            @input="onSearchHandle"
                            @blur="onBlurHandle"
                            @focus="onFocusHandle"
                          />

                          <ul
                            class="article-list bg-body"
                            v-if="showSearchResults"
                          >
                            <li
                              v-for="article in articles"
                              :key="article.id"
                              @click="addLinkedArticle(article)"
                            >
                              <div class="article-wrapper">
                                <img
                                  v-if="article.highlightedImageUrl"
                                  :src="`${baseUrl}${article.highlightedImageUrl}`"
                                  class="article-image"
                                />

                                <img
                                  v-else
                                  class="article-image"
                                  :src="'img/products/product-8.jpg'"
                                />
                                <div class="article-description">
                                  <div class="article-title">
                                    {{ article.title }}
                                  </div>
                                  <div class="article-code">
                                    {{ article.code }}
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>

                        <div
                          v-if="
                            article.linkedArticles &&
                            article.linkedArticles.length > 0
                          "
                        >
                          <div class="form-group row align-items-center mt-4">
                            <div class="col">
                              <div class="popup-gallery row">
                                <div
                                  v-for="(
                                    item, index
                                  ) in article.linkedArticles"
                                  :key="item.id"
                                  class="
                                    img-fluid
                                    col-xs-4 col-auto
                                    mb-4
                                    me-1
                                    img-wrapper
                                  "
                                >
                                  <div
                                    class="delete-image"
                                    @click="removeLinkedArticle(index)"
                                  >
                                    <i class="bx bx-x"></i>
                                  </div>
                                  <img
                                    v-if="item.highlightedImageUrl"
                                    :src="`${baseUrl}${item.highlightedImageUrl}`"
                                    class="
                                      img-thumbnail img-thumbnail-custom
                                      highlighted
                                    "
                                  />

                                  <img
                                    v-else
                                    class="
                                      img-thumbnail img-thumbnail-custom
                                      highlighted
                                    "
                                    :src="'img/products/product-8.jpg'"
                                  />

                                  <div class="article-title-list">
                                    {{ item.title }}
                                  </div>

                                  <div class="article-code-list">
                                    {{ item.code }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> -->

          <linked-articles v-model="article.linkedArticles" />
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-camera"></i>
                  <h2 class="card-big-info-title">Slike artikla</h2>
                  <p class="card-big-info-desc">
                    Označite sliku kao glavnu ili dodajte nove iz galerije
                  </p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center"
                    v-if="
                      article &&
                      article.gallery &&
                      article.gallery.images.length > 0
                    "
                  >
                    <div class="col">
                      <div
                        class="popup-gallery row"
                        v-if="article.gallery && article.gallery.images"
                      >
                        <div
                          class="img-fluid col-xs-4 col-auto mb-4 me-1 img-wrapper"
                          v-for="image in article.gallery.images"
                          @click.stop="highlightImage(image.id)"
                          :key="image.id"
                        >
                          <div
                            class="delete-image"
                            @click.prevent.stop="deleteImage(image.id)"
                          >
                            <i class="bx bx-x"></i>
                          </div>
                          <img
                            class="img-thumbnail img-thumbnail-custom"
                            :src="`${baseUrl}${image.url}`"
                            :class="{ highlighted: image.isHighlighted }"
                          />
                          <input
                            class="form-control form-control-modern img-order"
                            type="text"
                            v-model.number="image.ordinalNumber"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center">
                    <button
                      data-bs-toggle="modal"
                      type="button"
                      data-bs-target="#media-library"
                      class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4"
                    >
                      <i class="bx bx-upload text-lg-4 py-1" /> Upload
                    </button>
                    <modal id="media-library" css-class="modal-xl">
                      <h5 slot="header">
                        <strong>Biblioteka</strong>
                      </h5>
                      <div slot="body">
                        <media-library
                          v-if="article.gallery && article.gallery.images"
                          v-model="article.gallery.images"
                        />
                      </div>
                      <div slot="footer">
                        <div class="row">
                          <div class="col-md-12 text-end">
                            <button
                              type="button"
                              class="btn btn-primary px-4 mx-2"
                              @click.prevent="closeMediaLibraryModal"
                            >
                              Zatvori
                            </button>
                          </div>
                        </div>
                      </div>
                    </modal>
                    <modal id="upload-modal" css-class="modal-xl">
                      <h5 slot="header">
                        <strong> Upload image </strong>
                      </h5>
                      <div slot="body">
                        <MediaLibraryModalBody modal-id="upload-modal" />
                      </div>
                      <div slot="footer">
                        <div class="row">
                          <div class="col-md-12 text-end">
                            <button
                              type="button"
                              class="btn btn-primary px-4 mx-2"
                              @click.prevent="closeUploadModal('upload-modal')"
                            >
                              Zatvori
                            </button>
                          </div>
                        </div>
                      </div>
                    </modal>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-between">
        <div>
        </div>

        <div class="d-flex gap-3">
          <button
            type="button"
            @click="$router.go(-1)"
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
          >
            {{ translations.cancel }}
          </button>

          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>

      <modal id="delete-variation-image-modal" z-index="10000">
        <h5 slot="header">
          <strong>{{ translations.deleteVariationImage }}</strong>
        </h5>
        <div slot="body"></div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="deleteVariationImage"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="delete-attribute-modal">
        <h5 slot="header">
          <strong>{{ translations.deleteAttribute }}</strong>
        </h5>
        <div slot="body">
          <span v-html="removeAttributeModalText"> </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="removeLinkedAttribute"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="add-variation-modal" css-class="modal-2xl">
        <h5 slot="header">
          <strong>{{ translations.addVariation }}</strong>
        </h5>
        <div slot="body">
          <div class="form-group row align-items-center mb-3">
            <div
              class="col col-4"
              :class="{
                'col-4': variationAttributes.length % 3 === 0,
                'col-6': variationAttributes.length % 2 === 0,
              }"
              v-for="item in variationAttributes"
              :key="item.id"
            >
              <label class="label">{{ item.label }}</label>

              <treeselect
                v-model="item.model"
                :multiple="false"
                :options="item.values"
              >
                <label
                  slot="option-label"
                  slot-scope="{ node, labelClassName }"
                  :class="labelClassName"
                >
                  <div
                    v-if="variationAttributesObj[item.id].attributeStyle !== 1"
                  >
                    {{ node.label }}
                  </div>
                  <div v-else>
                    <div
                      :style="{
                        height: '20px',
                        width: '20px',
                        background: node.label,
                      }"
                    ></div>
                  </div>
                </label>

                <div
                  slot="value-label"
                  slot-scope="{ node }"
                  :style="{
                    width: '100%',
                    height: '100%',
                    padding:
                      variationAttributesObj[item.id].attributeStyle === 1
                        ? '0.5rem 0'
                        : 0,
                  }"
                >
                  <div
                    v-if="variationAttributesObj[item.id].attributeStyle === 1"
                    :style="{
                      backgroundColor: node.label,
                      width: '100%',
                      height: '100%',
                      overflow: 'hidden',
                      border: '1px solid #ccc',
                    }"
                  ></div>
                  <div v-else>{{ node.label }}</div>
                </div>
              </treeselect>
            </div>
          </div>

          <div class="form-group row align-items-center">
            <div class="col">
              <button
                data-bs-toggle="modal"
                type="button"
                data-bs-target="#media-library-variation"
                class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 mb-2"
              >
                <i class="bx bx-upload text-lg-4 py-1" /> Upload
              </button>

              <div
                class="form-group row align-items-center"
                v-if="selectedVariation && selectedVariation.gallery"
              >
                <div class="col">
                  <div class="popup-gallery row">
                    <div
                      class="img-fluid col-xs-4 col-auto mb-4 me-1 img-wrapper"
                      v-for="image in selectedVariation.gallery.images"
                      :key="image.id"
                    >
                      <div
                        class="delete-image"
                        @click.prevent.stop="openDeleteVariationModal(image.id)"
                      >
                        <i class="bx bx-x"></i>
                      </div>
                      <img
                        class="img-thumbnail img-thumbnail-custom"
                        :src="`${baseUrl}${image.url}`"
                        :class="{ highlighted: image.isHighlighted }"
                      />
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              SKU
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="SKU"
                v-model="selectedVariation.code"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Standardna cijena (KM)
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Standardna cijena"
                v-model="selectedVariation.mpc"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Dimenzije (DxŠxV) (cm)
            </label>

            <div class="col-lg-7 col-xl-6">
              <div class="row">
                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    placeholder="Duzina"
                    v-model="selectedVariation.length"
                  />
                </div>

                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern col-4"
                    placeholder="Sirina"
                    v-model="selectedVariation.width"
                  />
                </div>

                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern col-4"
                    placeholder="Visina"
                    v-model="selectedVariation.height"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Kolicina na zalihi
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Kolicina na zalihi"
                v-model="selectedVariation.stockAmount"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Tezina (kg)
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Tezina (kg)"
                v-model="selectedVariation.weight"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Akcijska cijena
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Akcijska cijena"
                v-model="selectedVariation.salePrice"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Opis
            </label>
            <div class="col-lg-7 col-xl-6">
              <textarea
                type="text"
                class="form-control form-control-modern"
                placeholder="Opis"
                v-model="selectedVariation.description"
              />
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                class="btn btn-primary px-4"
                type="button"
                @click.prevent.stop="saveVariation(selectedVariation)"
              >
                {{ translations.save }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.cancel }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="media-library-variation" css-class="modal-xl">
        <h5 slot="header">
          <strong>Biblioteka</strong>
        </h5>
        <div slot="body">
          <media-library
            v-if="selectedVariation.gallery"
            v-model="selectedVariation.gallery.images"
            modal-id="upload-modal-variation"
          />
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent="closeMediaLibraryModal"
              >
                Zatvori
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="upload-modal-variation" css-class="modal-xl">
        <h5 slot="header">
          <strong> Upload image </strong>
        </h5>
        <div slot="body">
          <MediaLibraryModalBody modal-id="upload-modal-variation" />
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent="closeUploadModal('upload-modal-variation')"
              >
                Zatvori
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="update-variation-modal" css-class="modal-2xl">
        <h5 slot="header">
          <strong>{{ translations.updateVariation }}</strong>
        </h5>
        <div slot="body">
          <div class="form-group row align-items-center mb-3">
            <div
              class="col col-4"
              :class="{
                'col-4':
                  (selectedVariation.variationCombinations || []).length % 3 === 0,
                'col-6':
                  (selectedVariation.variationCombinations || []).length % 2 === 0,
              }"
              v-for="item in selectedVariation.variationCombinations || []"
              :key="item.id"
            >
              <label class="label">{{
                variationAttributesObj[item.attributeId] && variationAttributesObj[item.attributeId].label
              }}</label>
              <select
                class="form-control"
                :key="item.id"
                v-model="item.attributeValueId"
              >
                <option :value="null">Bilo koja vrijednost</option>
                <option
                  :value="v.id"
                  v-for="v in (variationAttributesObj[item.attributeId] && variationAttributesObj[item.attributeId].values) || []"
                  :key="v.id"
                >
                  {{ v.label }}
                </option>
              </select>
            </div>
          </div>

          <div>
            <button
              data-bs-toggle="modal"
              type="button"
              data-bs-target="#media-library-variation-update"
              class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 mb-2"
            >
              <i class="bx bx-upload text-lg-4 py-1" /> Upload
            </button>
          </div>

          <div
            class="form-group row align-items-center"
            v-if="selectedVariation && selectedVariation.gallery"
          >
            <div class="col">
              <div class="popup-gallery row">
                <div
                  class="img-fluid col-xs-4 col-auto mb-4 me-1 img-wrapper"
                  v-for="image in selectedVariation.gallery.images"
                  :key="image.id"
                >
                  <div
                    class="delete-image"
                    @click.prevent.stop="openDeleteVariationModal(image.id)"
                  >
                    <i class="bx bx-x"></i>
                  </div>
                  <img
                    class="img-thumbnail img-thumbnail-custom"
                    :src="`${baseUrl}${image.url}`"
                    :class="{ highlighted: image.isHighlighted }"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              SKU
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="SKU"
                v-model="selectedVariation.code"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Standardna cijena (KM)
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Standardna cijena"
                v-model="selectedVariation.mpc"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Dimenzije (DxŠxV) (cm)
            </label>

            <div class="col-lg-7 col-xl-6">
              <div class="row">
                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    placeholder="Duzina"
                    v-model="selectedVariation.length"
                  />
                </div>

                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern col-4"
                    placeholder="Sirina"
                    v-model="selectedVariation.width"
                  />
                </div>

                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern col-4"
                    placeholder="Visina"
                    v-model="selectedVariation.height"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Kolicina na zalihi
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Kolicina na zalihi"
                v-model="selectedVariation.stockAmount"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Tezina (kg)
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Tezina (kg)"
                v-model="selectedVariation.weight"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Akcijska cijena
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Akcijska cijena"
                v-model="selectedVariation.salePrice"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Opis
            </label>
            <div class="col-lg-7 col-xl-6">
              <textarea
                type="text"
                class="form-control form-control-modern"
                placeholder="Opis"
                v-model="selectedVariation.description"
              />
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                class="btn btn-primary px-4 mx-2"
                type="button"
                @click.prevent.stop="saveVariation(selectedVariation)"
              >
                {{ translations.save }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.cancel }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="media-library-variation-update" css-class="modal-xl">
        <h5 slot="header">
          <strong>Biblioteka</strong>
        </h5>
        <div slot="body">
          <media-library
            v-if="selectedVariation.gallery"
            v-model="selectedVariation.gallery.images"
            modal-id="upload-modal-variation-update"
          />
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent="closeMediaLibraryModal"
              >
                Zatvori
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="upload-modal-variation-update" css-class="modal-xl">
        <h5 slot="header">
          <strong> Upload image </strong>
        </h5>
        <div slot="body">
          <MediaLibraryModalBody modal-id="upload-modal-variation-update" />
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent="closeUploadModal('upload-modal-variation-update')"
              >
                Zatvori
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
/* eslint-disable no-undef */
// import 'bootstrap/js/src/collapse';
import Datepicker from 'vuejs-datepicker';
import { format } from 'date-fns';
import { debounce } from 'lodash';
import Vue from 'vue';
import editor from '@tinymce/tinymce-vue';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
// import VSwatches from 'vue-swatches';
// Import the styles too, typically in App.vue or main.js
// import 'vue-swatches/dist/vue-swatches.css';

import api from '@/services/api';
import helpers from '@/services/helpers';
import { translations, pager } from '@/mixins';
import validations from './validation-schema/add';
import config from '@/config';
import FormError from '../shared/form-errors/FormError.vue';
import Modal from '../shared/modal/Modal.vue';
import LinkedArticles from './LinkedArticles.vue';
import MediaLibrary from './MediaLibrary.vue';
import MediaLibraryModalBody from '@/components/shared/MediaLibraryModal.vue';
import { EventBus } from '@/main';

import bs from 'vuejs-datepicker/dist/locale/translations/bs';

export default {
  name: 'CopyArticle',
  mixins: [translations, pager],
  components: {
    // VSwatches,
    Datepicker,
    editor,
    FormError,
    Treeselect,
    Modal,
    LinkedArticles,
    MediaLibrary,
    MediaLibraryModalBody,
  },
  validations: {
    article: validations,
  },
  data() {
    return {
      articleCodeExists: false,
      selectedImages: [],
      brand: {
        title: '',
        description: '',
      },
      tagName: '',
      baseUrl: config.baseUrl,
      showSearchResults: false,
      tabId: null,
      dropzone: '',
      dropzoneVariations: '',
      dropzoneCreateVariations: '',
      deleteImagesIds: [],
      highlightedImageId: null,
      selectedDeleteAttribute: null,
      attributeArticleType: 1,
      highlightImageUrl: '',
      attributeArticleTypes: [
        {
          id: 1,
          label: 'Jednostavni',
        },
        {
          id: 2,
          label: 'Varijabilni',
        },
      ],
      attributeId: null,
      selectedVariation: {
        gallery: {
          images: [],
        },
      },
      deleteVariationImageId: null,
      gallery: [],
    };
  },
  computed: {
    appSettings() {
      return config.appSettings;
    },
    frontBaseUrl() {
      return config.frontBaseUrl;
    },
    bs() {
      return bs;
    },
    articleStates() {
      return helpers.articleStates;
    },
    disabledDates() {
      const date = new Date();
      date.setDate(date.getDate() - 1);

      return {
        to: date,
      };
    },
    articleModalText() {
      return this.translations.areYouSureArticle.replace(
        '{article}',
        `<strong>${this.article.title}</strong>`
      );
    },
    removeAttributeModalText() {
      return this.translations.areYouSureAttributeArticle;
    },
    article() {
      const article = this.$store.getters.getCopyOfArticle;

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.gallery = article?.gallery?.images?.map((item) => ({
        ...item,
      }));

      return article;
    },
    categories() {
      return this.$store.getters.getSimplifiedCategories;
    },
    brands() {
      return this.$store.getters.getBrands;
    },
    taxes() {
      return this.$store.getters.getTaxes;
    },
    measurementUnits() {
      return this.$store.getters.getMeasurementUnits;
    },
    tabs() {
      return this.$store.getters.getTabs;
    },
    categoriesTreeView() {
      return this.$store.getters.getCategoriesTree;
    },
    articles() {
      return this.$store.getters.getArticles;
    },
    areas() {
      const areas = this.$store.getters.getInterestsAreas;

      if (!areas.length) {
        return [];
      }

      const selectAll = {
        id: 0,
        label: 'Oznaci sve',
      };

      return [
        selectAll,
        ...areas.map((item) => {
          return {
            label: item.title,
            id: item.id,
          };
        }),
      ];
    },
    attributesObj() {
      return this.$store.getters.getAttributesAsObj;
    },
    allAttributes() {
      return this.$store.getters.getAttributes;
    },
    // Mapped selected attributes used on add variation modal
    variationAttributes() {
      return this.article?.articleAttributes?.map((item) => {
        const attribute = this.attributesObj[item.attributeId];

        const values = item.attributeValues.map((a) => {
          const obj = attribute?.attributeProperties?.find((i) => i.id === a);
          return {
            ...a,
            id: a,
            label: obj?.label,
          };
        });

        return {
          ...item,
          id: item.attributeId,
          label: attribute?.title,
          values,
          model: null,
        };
      }) || [];
    },
    variations() {
      return this.$store.getters.getArticleVariations;
    },
    variationAttributesObj() {
      const obj = {};
      this.variationAttributes.forEach((item) => {
        obj[item.id] = item;
      });
      return obj;
    },
    companies() {
      const companies = this.$store.getters.getCompanies.map((item) => {
        return {
          id: item.id,
          label: item.title,
        };
      });
      return companies;
    },
    tags() {
      return this.$store.getters.getTags;
    },
  },
  methods: {
    closeMediaLibraryModal() {
      $('#media-library').modal('hide');
    },
    closeUploadModal(modalId) {
      $(`#${modalId}`).modal('hide');
      EventBus.$emit(`clear-upload-modal-data:${modalId}`);
    },
    customFormatter(date) {
      return format(date, 'dd.MM.yyyy.');
    },
    handeIsNewArticleChange({ isNewArticle }) {
      if (isNewArticle) {
        const currentDate = new Date();
        (this.article.isNewArticleFromDate =
          this.article.isNewArticleFromDate || new Date()),
          (this.article.isNewArticleToDate =
            this.article.isNewArticleToDate ||
            new Date().setDate(currentDate.getDate() + 30));
      }
    },
    handleMinOrderQuantity() {
      this.article.orderQuantityRatio = this.article.minOrderQuantity;
    },
    handleOrderQuantityRatio() {
      this.article.minOrderQuantity = this.article.orderQuantityRatio;
    },
    addTab() {
      if (!this.tabId) return;

      const exist = this.article.tabs.find((tab) => tab.tabId === this.tabId);

      // There is already tab with that id in the list
      if (exist) return;

      const selectedTab = this.tabs.find((tab) => tab.id === this.tabId);
      selectedTab.tabId = selectedTab.id;
      selectedTab.tabTitle = selectedTab.title;
      selectedTab.content = '';
      this.article.tabs.push(selectedTab);
    },
    checkIfArticleCodeExists: debounce(function (){
      if (!this.article.code || !this.article.code.trim()) {
        this.articleCodeExists = false;
        return;
      }

      api
        .checkIfArticleCodeExists(0, this.article.code)
        .then(() => {
          // this.$toast.info(response?.data?.info);
          this.articleCodeExists = false;
        })
        .catch(() => {
          this.articleCodeExists = true;
        });
    }, 500),
    submitForm() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$toast.error(this?.translations?.forms?.notValid);
        this.$nextTick(() => {
          let elem = document.querySelector('.has-danger');
          elem.scrollIntoView(true);
          let saveBtn = document.querySelection('submit-button');
          saveBtn.focus();
        });
        return;
      }

      const {
        title,
        description,
        code,
        catalogNumber,
        shortDescription,
        nc,
        vpc,
        mpc,
        unitOfMeasureId,
        nettoWeight,
        categoryIds,
        isVisibleOnWeb,
        isReplaceable,
        taxId,
        brandId,
        videoUrl,
        tabs: editors,
        interestsAreasIds,
        attributeArticleType,
        // companyId,
        isNewArticle,
        tagsIds,
        presentationAvailable,
        disableSelling,
        disableSellingB2C,
        bruttoWeight,
        articleState,
        isNewArticleFromDate,
        isNewArticleToDate,
        minOrderQuantity,
        maxOrderQuantity,
        length,
        width,
        height,
        reviewAllowed,
        gallery,
        orderQuantityRatio,
        b2BProduct,
        b2CProduct,
        articleAvailableInDays,
      } = this.article;

      const payload = {
        title,
        description,
        code,
        catalogNumber,
        shortDescription,
        nc,
        vpc,
        mpc,
        unitOfMeasureId,
        nettoWeight,
        categoryIds,
        isVisibleOnWeb,
        isReplaceable,
        taxId,
        brandId,
        videoUrl,
        editors,
        interestsAreasIds,
        attributeArticleType,
        // companyId,
        isNewArticle,
        tagsIds,
        presentationAvailable,
        disableSelling,
        disableSellingB2C,
        bruttoWeight,
        articleState,
        isNewArticleFromDate,
        isNewArticleToDate,
        minOrderQuantity,
        maxOrderQuantity: maxOrderQuantity || null,
        length,
        width,
        height,
        reviewAllowed,
        tabs: editors,
        mediaLibraryArticleImages: gallery?.images,
        orderQuantityRatio,
        b2BProduct,
        b2CProduct,
        articleAvailableInDays:
          articleAvailableInDays?.trim()?.length === 0
            ? null
            : articleAvailableInDays,
      };

      if (!payload.isNewArticle) {
        delete payload.isNewArticleFromDate;
        delete payload.isNewArticleToDate;
      } else {
        payload.isNewArticleFromDate = new Date(payload.isNewArticleFromDate);
        payload.isNewArticleToDate = new Date(payload.isNewArticleToDate);
      }

      api
        .createArticle(payload)
        .then((response) => {
          const requests = [];

          if (this.article.linkedArticles.length > 0) {
            const linkedArticlesIds = this.article.linkedArticles.map(
              (item) => item.id
            );
            requests.push(
              api.createLinkedArticles({
                articleId: response.data.data,
                linkedArticlesIds,
              })
            );
          }

          if (this.article.articleAttributes.length > 0) {
            const payload = [];

            this.article.articleAttributes.forEach((item) => {
              payload.push({
                articleId: response.data.data,
                attributeId: item.id,
                attributeValuesIds: item.model,
              });
            });

            requests.push(api.createArticleAttributes(payload));

            if (this.articleAttributeType !== 1) {
              this.variations = this.variations.map((item) => {
                return {
                  ...item,
                  weight: parseFloat(item.weight, 10),
                  height: parseFloat(item.height, 10),
                  length: parseFloat(item.length, 10),
                  width: parseFloat(item.width, 10),
                  mpc: parseFloat(item.mpc, 10),
                  salePrice: parseFloat(item.salePrice, 10),
                  stockAmount: parseInt(item.stockAmount, 10),
                  articleId: response.data.data,
                };
              });
              requests.push(api.createVariations(this.variations));
            }
          }

          if (requests.length > 0) {
            Promise.all(requests)
              .then(() => {
                this.$toast.info('Artikal uspjesno kopiran.');
                this.$router.push({ name: 'Articles' });
              })
              .catch((err) => {
                this.$toast.error(err?.response?.data?.info || 'Desila se greška');
              });
          } else {
            this.$toast.info('Artikal uspjesno kopiran.');
            this.$router.push({ name: 'Articles' });
          }
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    highlightImage(id) {
      const images = this.gallery;
      this.gallery = images.map((image) => {
        image.isHighlighted = false;
        return image;
      });

      const index = images.findIndex((image) => image.id === id);

      this.gallery[index].isHighlighted = true;
      this.highlightedImageId = id;
    },
    deleteImage(id) {
      const images = this.article.gallery.images;
      this.article.gallery.images = images.filter((image) => image.id !== id);
      this.deleteImagesIds.push(id);

      if (id === this.highlightedImageId) {
        this.highlightedImageId = null;
      }
    },
    deleteArticle() {
      api
        .deleteArticles([this.article.id])
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Articles' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
          this.$router.push({ name: 'Articles' });
        });
    },
    removeTab(index) {
      this.article.tabs.splice(index, 1);
    },
    addAttribute() {
      if (!this.attributeId) {
        this.$toast.error('Izaberite atribut');
        return;
      }

      const attribute = this.attributesObj[this.attributeId];

      if (!attribute) return;

      this.$nextTick(() => {
        const attributeProperties = attribute.attributeProperties.map(
          (item) => item
        );

        this.$set(attribute, 'attributeProperties', attributeProperties);
        this.$set(attribute, 'attributeValues', []);
        this.$set(attribute, 'attributeId', attribute.id);
        this.$set(attribute, 'model', []);

        const articleAttributes = this.article.articleAttributes;

        if (articleAttributes.length === 0) {
          articleAttributes.push(attribute);
        } else {
          const item = articleAttributes.find(
            (i) => i.attributeId === attribute.id
          );
          if (!item) {
            articleAttributes.push(attribute);
          } else {
            this.$toast.error('Atribut je već dodan');
          }
        }

        this.$set(this.article, 'articleAttributes', articleAttributes);
      });
    },
    removeLinkedAttribute() {
      const attribute =
        this.article.articleAttributes[this.selectedDeleteAttribute];

      api
        .deleteArticleAttribute({
          articleId: this.article.id,
          attributeId: attribute.attributeId,
        })
        .then(() => {
          this.$toast.info('Atribut uspješno uklonjen.');
          this.article.articleAttributes.splice(
            this.selectedDeleteAttribute,
            1
          );
        })
        .catch(() => {
          this.$toast.error('Dogodila se greška!');
        });
    },
    selectLinkedAttribute(index) {
      this.selectedDeleteAttribute = index;
    },
    onAttributeChange(node, instanceId) {
      api
        .deleteArticleAttributeValueId({
          articleId: this.article.id,
          attributeId: instanceId,
          attributeValueId: node.id,
        })
        .then(() => {
          this.$toast.info('Vrijednost atributa uspješno uklonjena');
          this.$forceUpdate();
        });
    },
    selectVariation(variation) {
      // Add variation
      if (!variation) {
        this.selectedVariation = {
          title: '',
          code: '',
          enabled: false,
          mpc: null,
          salePrice: null,
          stockAmount: 0,
          weight: 0,
          width: 0,
          height: 0,
          length: 0,
          description: '',
          gallery: {
            images: [],
          },
        };
      } else {
        // Update variation
        this.selectedVariation = variation;
      }
    },
    saveVariation(variation) {
      const requestData = {
        articleId: this.article.id,
        title: variation.title || 'test',
        description: variation.description,
        code: variation.code,
        weight: parseFloat(variation.weight, 10),
        height: parseFloat(variation.height, 10),
        length: parseFloat(variation.length, 10),
        width: parseFloat(variation.width, 10),
        mpc: parseFloat(variation.mpc, 10),
        salePrice: parseFloat(variation.salePrice, 10),
        stockAmount: parseInt(variation.stockAmount, 10),
        mediaLibraryArticleImages: [],
        variationCombinations: [],
      };

      // Create variation
      if (!variation.id) {
        this.variationAttributes.forEach((item) => {
          requestData.variationCombinations.push({
            attributeId: item.id,
            attributeValueId: item.model,
          });
        });

        requestData.mediaLibraryArticleImages =
          this.selectedVariation.gallery.images.map((item) => ({
            ...item,
            mediaLibraryFileId: item.id,
          }));
      }

      // Update variation
      if (variation.id) {
        requestData.id = variation.id;

        requestData.mediaLibraryArticleImages =
          this.selectedVariation.gallery.images.map((item) => ({
            ...item,
            mediaLibraryFileId: item.id,
          }));

        variation.variationCombinations.forEach((item) => {
          requestData.variationCombinations.push({
            attributeId: item.attributeId,
            attributeValueId: item.attributeValueId,
          });
        });

        api.updateVariation(requestData).then(() => {
          this.$store.dispatch('getArticleVariations', this.$route.params.id);
          $('#update-variation-modal').modal('hide');
        });
        return;
      }

      api.createVariation(requestData).then(() => {
        this.$store.dispatch('getArticleVariations', this.$route.params.id);
        $('#add-variation-modal').modal('hide');
      });
    },
    openDeleteVariationModal(imageId) {
      this.deleteVariationImageId = imageId;
      $('#delete-variation-image-modal').modal('show');
    },
    deleteVariationImage() {
      api
        .deleteVariationImage({
          imageId: this.deleteVariationImageId,
          variationId: this.selectedVariation.id,
        })
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$store.dispatch('getArticleVariations', this.$route.params.id);
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
          this.$store.dispatch('getArticleVariations', this.$route.params.id);
        });
    },
    handleChangeAreas(node) {
      if (node.id === 0) {
        // All selected
        if (this.article.interestsAreasIds.length === this.areas.length - 1) {
          Vue.nextTick(() => {
            this.article.interestsAreasIds = [];
          });
        } else {
          Vue.nextTick(() => {
            this.article.interestsAreasIds = this.areas
              .filter((i) => i.id !== 0)
              .map((i) => i.id);
          });
        }
      }
    },
    addTag() {
      $('#add-tag').modal('show');
    },
    saveTag() {
      api
        .createTag({ title: this.tagName })
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        })
        .finally(() => {
          $('#add-tag').modal('hide');
          this.tagName = '';
        });
    },
    addBrand() {
      $('#add-brand').modal('show');
    },
    saveBrand() {
      const { title, description } = this.brand;

      const formData = new FormData();

      formData.append('title', title);
      formData.append('description', description);

      if (this.$refs.brandImage.files[0]) {
        formData.append('Image', this.$refs.brandImage.files[0]);
      }
      api
        .createBrand(formData)
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .catch((err) => {
          this.$toast.error(err);
        })
        .finally(() => {
          $('#add-brand').modal('hide');
          this.brand.title = '';
          this.brand.description = '';
          this.$store.dispatch('getBrands', {
            sortBy: 'title',
            isSortAscending: true,
            retrieveAll: true,
          });
        });
    },
    handleMpcChange() {
      this.article.vpc = parseFloat((this.article.mpc / 1.17).toFixed(2), 10);
    },
    handleVpcChange() {
      this.article.mpc = parseFloat((this.article.vpc * 1.17).toFixed(2), 10);
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // this.$store.dispatch('getArticleById', this.$route.params.id);
    // this.$store.dispatch('getSimplifiedCategories', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    // this.$store.dispatch('getMeasurementUnits', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    // this.$store.dispatch('getTaxes', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    // this.$store.dispatch('getBrands', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    // this.$store.dispatch('getTabs', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    // this.$store.dispatch('getInterestsAreas', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    // this.$store.dispatch('getAttributes', { sortBy: 'title', isSortAscending: true, retrieveAll: true});
    // this.$store.dispatch('getArticleVariations', this.$route.params.id);
    // this.$store.dispatch('getCompanies', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    // this.$store.dispatch('getTags', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
  },
  watch: {
    'article.gallery.images'() {
      this.gallery = this.article?.gallery?.images?.map((item) => {
        item.mediaLibraryFileId = item.mediaLibraryFileId || item.id;
        return item;
      });
    },
  },
};
</script>

<style lang="scss">
@import './assets/scss/article.scss';
</style>
